const Modal = () => {
  const modalOpeners = Array.from(document.querySelectorAll(".modal-opener"));
  if (!modalOpeners.length) return;

  modalOpeners.forEach((opener) => {
    opener.addEventListener("click", (e) => {
      e.preventDefault();
      const idModal = opener.dataset.modal;
      if (!idModal) return;

      const modalElement = document.getElementById(idModal);
      if (!modalElement) return;

      //Close other modals
      document.querySelectorAll("dialog[open]").forEach((openModal) => {
        if (openModal !== modalElement) {
          openModal.classList.remove("hide");
          openModal.close();
        }
      });

      //Open current modal
      modalElement.classList.remove("hide");
      modalElement.showModal();

      //Animation modal
      const onAnimationEnd = () => {
        modalElement.classList.remove("hide");
        modalElement.close();
        modalElement.removeEventListener("animationend", onAnimationEnd);
      };

      const handleModalClose = (e) => {
        modalElement.classList.add("hide");
        modalElement.addEventListener("animationend", onAnimationEnd);
      };

      //Modal closers click
      const insideClosers = Array.from(
        modalElement.querySelectorAll(".modal-closer")
      );
      if (!insideClosers.length) return;

      insideClosers.forEach((closer) => {
        closer.addEventListener("click", handleModalClose, {once: true});
      });

      //Backdrop click
      const handleModalClick = ({currentTarget, target}) => {
        const isClickedOnBackdrop = target === currentTarget;

        if (isClickedOnBackdrop) {
          modalElement.removeEventListener("click", handleModalClick);
          handleModalClose();
        }
      };

      modalElement.addEventListener("click", handleModalClick);

      //Escape click
      const handleEscapeClick = (event) => {
        event.preventDefault();
        handleModalClose();
      };

      modalElement.addEventListener("cancel", handleEscapeClick, {once: true});
    });
  });
};

export default Modal;
